import React from 'react';
import { useAuth } from '../Auth/AuthContext';
import { useUserProfile } from '../../hooks/useProfileImage';
import whiteLogo from '../../whiteLogo3.png';
import './Sidebar.css';

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  isOpen?: boolean;
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ activeTab, onTabChange, isOpen = false, onClose }) => {
  const { user, signOut } = useAuth();
  const { profileImageUrl, displayName } = useUserProfile();
  
  const navItems = [
    { id: 'dashboard', label: 'My Reports', icon: null },
    { id: 'shared', label: 'Shared', icon: null },
    { id: 'settings', label: 'Settings', icon: null }
  ];

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleNavItemClick = (tabId: string) => {
    onTabChange(tabId);
    if (onClose) {
      onClose(); // Close sidebar on mobile after selecting a tab
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && onClose && (
        <div className="sidebar-overlay" onClick={onClose} />
      )}
      
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src={whiteLogo} alt="PropertyReporter Logo" className="logo-icon" />
          </div>
          {onClose && (
            <button className="sidebar-close" onClick={onClose}>
              ×
            </button>
          )}
        </div>
        
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => handleNavItemClick(item.id)}
            >
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>
        
        <div className="sidebar-footer">
          <div className="user-profile">
            <div className="user-avatar">
              {profileImageUrl ? (
                <img 
                  src={profileImageUrl} 
                  alt="Profile" 
                  className="profile-image"
                />
              ) : (
                <span>
                  {(displayName || user?.displayName)
                    ? (displayName || user?.displayName || '').split(' ').map((n: string) => n[0]).join('').toUpperCase()
                    : user?.email?.[0]?.toUpperCase() || 'U'
                  }
                </span>
              )}
            </div>
            <div className="user-info">
              <div className="user-name">
                {displayName || user?.displayName || user?.email?.split('@')[0] || 'User'}
              </div>
              <div className="user-email">{user?.email || 'No email'}</div>
            </div>
          </div>
          <button className="sign-out-btn" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>
      </div>
    </>
  );
};
